import { render } from "./ModalClientCopyTo.vue?vue&type=template&id=44a8e003"
import script from "./ModalClientCopyTo.vue?vue&type=script&lang=js"
export * from "./ModalClientCopyTo.vue?vue&type=script&lang=js"

import exportComponent from "D:\\01.WorkData\\05.WebProjects\\04.SourceCode\\02.Vue\\project_110_008\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__